export function openPopupAndWaitForClose(url: string): Promise<void> {
    return new Promise((resolve) => {
        const width = 600;
        const height = 700;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        const popup = window.open(
            url,
            "nango-connect",
            `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no`
        );

        const interval = setInterval(() => {
            if (!popup || popup.closed) {
                clearInterval(interval);
                resolve();
            }
        }, 500);
    });
}
